import type { EmailAddressListResponse, EmailAddressSuggestionsResponse } from "@/schema"

import { apiContextFetch, type ApiContext } from "@/hooks/api/base"

export function fetchUnsubscribedEmailAddresses(
  context: ApiContext,
  pageParams?: { page?: number; per_page?: number }
) {
  const searchParams = new URLSearchParams()
  if (pageParams?.page) searchParams.set("page", String(pageParams.page))
  if (pageParams?.per_page) searchParams.set("per_page", String(pageParams.per_page))

  const route = `email_addresses/unsubscribed?${searchParams.toString()}`
  return apiContextFetch<EmailAddressListResponse>(context, route)
}

export function fetchEmailAddressSuggestions(context: ApiContext, query: string) {
  const searchParams = new URLSearchParams()
  searchParams.set("query", query)

  return apiContextFetch<EmailAddressSuggestionsResponse>(
    context,
    `email_addresses/suggestions?${searchParams.toString()}`
  )
}
